module.exports = __webpack_public_path__ + "static/media/no-scans.a3f18d47.svg";